import { render, staticRenderFns } from "./verification-code.vue?vue&type=template&id=7ebb9fee&"
import script from "./verification-code.vue?vue&type=script&lang=js&"
export * from "./verification-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports